import { render, staticRenderFns } from "./IseqButton.vue?vue&type=template&id=3895ca6c&scoped=true"
import script from "./IseqButton.vue?vue&type=script&lang=js"
export * from "./IseqButton.vue?vue&type=script&lang=js"
import style0 from "./IseqButton.vue?vue&type=style&index=0&id=3895ca6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3895ca6c",
  null
  
)

export default component.exports